import T from 'utils/T';
import ex from 'utils/ex';
import './Segment.css';
// 디자인적인 분리 - 소영역 - rounded white box
// 대영역은 Division
export default function Segment(props) {
  const {
    full,
    direction, // DIRECTION_HORIZONTAL | DIRECTION_VERTICAL
    ...rest
  } = props || {};

  return (
    <div {...ex(['Segment', direction, { full }], rest)}>
    </div>
  );
}
